<template>
    <section class="form-elegant">
        <row>
            <column md="5" class="mx-auto">
                <card>
                    <card-body class="mx-4">
                        <div v-show="error" class="alert alert-danger fade show" role="alert">
                            {{ alertMessage }}
                        </div>
                        <div class="text-center">
                            <h3 class="mb-5 mt-4 font-weight-bold text-uppercase"><strong>{{$t('sign')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('in')}}</strong></h3>
                        </div>
                        <form @submit.prevent="validateUser">
                            <md-field :class="getValidationClass('email')">
                                <md-icon>email</md-icon>
                                <label>{{$t('your_email')}}</label>
                                <md-input type="email" v-model="form.email" name="email" :disabled="sending"></md-input>
                                <span class="md-error" v-if="!$v.form.email.required">{{$t('required.email')}}</span>
                                <span class="md-error" v-else-if="!$v.form.email.email">{{$t('invalid.email')}}</span>
                            </md-field>
                            <md-field :class="getValidationClass('password')">
                                <md-icon>vpn_key</md-icon>
                                <label>{{$t('your_password')}}</label>
                                <md-input type="password" v-model="form.password" name="password" :disabled="sending"></md-input>
                                <span class="md-error" v-if="!$v.form.password.required">{{$t('required.password')}}</span>
                                <span class="md-error" v-else-if="!$v.form.password.password">{{$t('required.password')}}</span>
                            </md-field>
                            <p class="font-small blue-text d-flex justify-content-end pb-3"><localized-link to="forgot-password" class="blue-text ml-1">{{$t('forgot_password')}}?</localized-link></p>
                            <md-progress-bar md-mode="indeterminate" v-if="sending" />
                            <div class="text-center mb-3">
                                <btn :disabled="sending" type="submit" color="info" class="btn-block btn-rounded">{{$t('signin')}}</btn>
                            </div>
                        </form>
                    </card-body>
                    <modal-footer class="mx-auto pt-3 mb-1 text-center">
                        <p class="font-small grey-text d-flex justify-content-center">{{$t('not_a_member')}} <localized-link to="register" class="blue-text ml-1">{{$t('signup')}}</localized-link></p>
                    </modal-footer>
                </card>
            </column>
            <!-- <div class="mx-auto">
                <h1><i class="fa fa-power-off"></i> {{$t('maintenance_message_1')}}</h1>
                <div class="well">
                    <p>{{$t('maintenance_message_2')}}<br>{{$t('maintenance_message_3')}}<br>{{$t('maintenance_message_4')}}<br></p>
                    {{$t('maintenance_message_5')}}
                </div>
            </div> -->
        </row>
    </section>
</template>

<script>
import { Row, Column, Btn, ModalFooter, Card, CardBody } from 'mdbvue';
import { mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { getLoggedUser, hasCompleteAccount, isVenteApp } from '../services/User.service'
import LocalizedLink from '@/components/Menu'

export default {
    name: 'Authentication',
    mixins: [validationMixin],
    data(){
        return{
            form: {
                email: null,
                password: null
            },
            sending: false,
            error: false,
            alertMessage: null
        }
    },
    validations: {
        form: {
            email: {
                required,
                email
            },
            password: {
                required
            }
        }
    },
    methods:{
        ...mapActions(['setUserDetails']),
        login(){
            this.sending = true
            this.error = false
            const { email, password } = this.form
            this.$store.dispatch('login', { email, password }).then((resp) => {
                if(resp.data.user_info.authFailed == 0){
                    this.sending = false
                    const userId = resp.data.user_info.id
                    getLoggedUser(userId).then(response => {
                        this.setUserDetails(response.data.user_info);
                    }).catch(error => {
                        this.$store.dispatch('logout');
                        console.log(error);
                    })

                    if (hasCompleteAccount(resp.data.user_info)) {
                      if (isVenteApp()) {
                        this.$router.push({name:'Questionnaire'});
                      } else {
                        this.$router.push({name:'QuestionnaireInstructions'});
                      }

                    } else {
                      this.$router.push({name: 'Account'});
                    }
                }else{
                    this.$router.push({name:'Authentication'});
                    this.sending = false
                    this.error = true;
                    this.alertMessage = this.$t('incorrect_email_or_password')
                }
            })
        },
        validateUser () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.login()
            }
        },
        getValidationClass (fieldName) {
            const field = this.$v.form[fieldName]

            if (field) {
                return {
                    'md-invalid': field.$invalid && field.$dirty
                }
            }
        },
        getEmail(){
            let searchParams = new URLSearchParams(window.location.search)
            if(searchParams.has('email')){
                let value = searchParams.get('email')
                this.form.email = value;
            }
        }
    },
    components: {
        Row,
        Column,
        Btn,
        ModalFooter,
        Card,
        CardBody,
        LocalizedLink
    },
    mounted(){
        console.log("Env config: ", process.env);
        this.getEmail();
    }
}
</script>

<style scoped>
.form-elegant .font-small {
font-size: 0.8rem;
}
.form-elegant .z-depth-1a {
-webkit-box-shadow: 0 2px 5px 0 rgba(55, 161, 255, 0.26), 0 4px 12px 0 rgba(121, 155, 254, 0.25);
box-shadow: 0 2px 5px 0 rgba(55, 161, 255, 0.26), 0 4px 12px 0 rgba(121, 155, 254, 0.25);
}
.form-elegant .z-depth-1-half,
.form-elegant .btn:hover {
-webkit-box-shadow: 0 5px 11px 0 rgba(85, 182, 255, 0.28), 0 4px 15px 0 rgba(36, 133, 255, 0.15);
box-shadow: 0 5px 11px 0 rgba(85, 182, 255, 0.28), 0 4px 15px 0 rgba(36, 133, 255, 0.15);
}
.md-progress-bar {
position: absolute;
top: 0;
right: 0;
left: 0;
}
@media (max-width: 425px){
.card-body{
margin: 0 !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Authentication.vue